import React from 'react';
import { PartitionOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';
import {
  checkProductsSubscriptionShield,
  checkIsGDSNProducts,
  validateProductOwner,
  validateAllActiveProducts,
  validateSubscriptedShield,
  verifyGDSNProductShield,
} from './utils';

import messages from 'i18n/messages/home';

import userSelectors from '@redux/user/selectors';

import { RibbonButton } from 'common/components';
import { useGlobalModal } from 'hooks';

const GDSNPublication = ({
  products,
  isFullView = false,
  productFull = {},
}) => {
  const userInfo = useSelector(userSelectors.makeSelectUserInfo());

  const { MODAL_NAMES, openModal } = useGlobalModal();

  const checkEnabledGDSNPublishGrid = (products, isRivirGdsnParty) => {
    /*
      Enabled Condition:
      - All owner products
      - All Products active
      - No subscribed products
      - No GDSN products
    */

    if (products?.length === 0) return false;

    const isOwner = validateProductOwner(products);
    const allActiveProducts = validateAllActiveProducts(products);
    const isRIVIRGdsnParty = Boolean(isRivirGdsnParty);
    const hasSubscribedProducts = checkProductsSubscriptionShield(products);
    const hasGDSNProduct = checkIsGDSNProducts(products);

    return (
      isOwner &&
      allActiveProducts &&
      isRIVIRGdsnParty &&
      !hasSubscribedProducts &&
      !hasGDSNProduct
    );
  };

  const checkEnableGDSNPublishFull = () => {
    const isOwner = Boolean(productFull?.isOwner);
    const isActive = Boolean(productFull?.status?.toLowerCase() === 'active');
    const isSubscribedProduct = validateSubscriptedShield(productFull);
    const isGdsnShield = verifyGDSNProductShield(productFull);

    return isOwner && isActive && !isSubscribedProduct && !isGdsnShield;
  };

  return (
    <>
      <RibbonButton
        size='small'
        className='button-item-dropdown'
        icon={<PartitionOutlined />}
        label={messages.GDSNPublicationSetup}
        onClick={() => openModal(MODAL_NAMES.PUBLICATION_SETUP_MODAL)}
        disabled={
          isFullView
            ? !checkEnableGDSNPublishFull()
            : !checkEnabledGDSNPublishGrid(products, userInfo?.isRivirGdsnParty)
        }
      />
    </>
  );
};

export default GDSNPublication;
